export { rtiTranslations } from './lib/locales';
